<template>
	<div class="role">
		<div class="pages_wrap">
			<div class="gpt_wrap">
				<div class="content_wrap" ref="scrollDiv" :style="{height: contentHeight + 'px'}">
					<div class="medin_box">
						<el-image class="medin_avatar" :src="require('@/assets/images/avatar.png')"></el-image>
						<div class="medin_desc">
							你好，
							我是人工智能语言模型
							<div class="medin_desc_t">我可以回答你的问题，为你提供有用信息，帮助你完成创作。</div>
						</div>
					</div>
					<div v-for="(item, index) in list" :key="index">
						<div class="user_box" v-if="item.type == 'user' && item.fail != 'fail'">
							<el-image class="user_avatar" :src="require('@/assets/images/nan-avatar.png')"></el-image>
							<div class="user_question">
								{{item.result}}
							</div>
						</div>
						<div class="medin_box" v-if="item.type != 'user' && item.fail != 'fail'">
							<el-image class="medin_avatar" :src="require('@/assets/images/avatar.png')"></el-image>
							<div class="medin_answer" v-html="item.result" >
								
							</div>
							<div class="medin_tip">AI⽣成内容仅供参考，不代表平台⽴场。</div>
						</div>
						<div class="fail_cell" v-if="item.fail == 'fail'">
							<div class="to_tips">您撤回了一条消息</div>
							<div class="to_tips ">{{item.msg ? item.msg : '抱歉，因您发送的消息可能含有不良信息，消息发送失败'}}</div>
						</div>
					</div>
					<div class="chat_box " v-if="isLoading">
						<div class="chat_avatar">
							<el-image class="medin_avatar" :src="require('@/assets/images/avatar.png')"></el-image>
						</div>
						<div class="chat_content">
							<div class="chat_text">稍等片刻，正在为您解答 <span class="tips1" v-if="isTip1"></span><span class="tips2" v-if="isTip2"></span><span class="tips3" v-if="isTip3"></span> </div>
						</div>
					</div>
				</div>
				
				<div class="gpt_foot">
					<el-input
					  type="textarea"
					  placeholder="请输入问题"
					  v-model="gptVal"
					  @input="handleInput"
					  show-word-limit
					  maxRows=6
					  @keydown.enter.native="handleEnter"
					  @keyup.enter.native="handleSub"
					  class="input_box"
					>
					</el-input>
					<el-image class="sub_btn" :src="require('@/assets/images/btn_fasong.png')" @click="handleSub"></el-image>
				</div>
			</div>
			<!-- :style="{width: isMenusShow ? '300px' : '0px'}" -->
			<div class="history_list"  v-if="isMenusShow">
				<div class="history_title">历史记录</div>
				<div class="history_item_wrap" :style="{height: historyHeight + 'px'}" v-if="historyList && historyList.length > 0">
					<div class="history_item" v-for="(item, index) in historyList" @click="handleHistory(item)">
						{{item.ask}}
					</div>
				</div>
				<div class="no_history" v-if="historyList.length <= 0">
					<el-image class="no_data_img" :src="require('@/assets/images/gpt_no_data.png')"></el-image>
					<div class="no_data_text">暂无记录</div>
				</div>
			</div>
			<div class="history_menu" :style="{right: isMenusShow ? '320px' : '20px'}" @click="handleMenus">{{isMenusShow ? '隐藏历史记录' : '历史记录'}}</div>
			<!-- <el-image class="aside_img" @click="handleMenus" :style="{right: isMenusShow ? '10px' : '300px'}" :src="isMenusShow ? require('@/assets/images/aside_left.png') : require('@/assets/images/aside_right.png')"></el-image> -->
		</div>
	</div>
</template>

<script>
	import { getGpt } from "@/utils/axios"
	
	export default{
		name: 'gpt',
		
		data() {
			return {
				list: [],
				gptVal: '',
				qVal: '',
				contentHeight: '',
				historyHeight: '',
				answer: '',
				isLoading: false,
				isTip1: false,
				isTip2: false,
				isTip3: false,
				historyList: [],
				isMenusShow: false,
			}
		},
		mounted() {
			this.contentHeight = (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 290
			this.historyHeight = (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 140
			this.handleList();
		},
		watch:{
			isLoading(newVal, oldVal) {
				if(newVal) {
					this.isTip1 = true
					setTimeout(()=> {
						this.isTip2 = true
					}, 500);
					setTimeout(()=> {
						this.isTip3 = true
					}, 1000);
				}
			}
		},
		methods: {
			handleMenus() {
				this.isMenusShow = !this.isMenusShow
			},
			handleList() {
				let data = {
					act: 'list'
				}
				getGpt(data).then((res) => {
					if(res.code == 200) {
						if(res.data != '') {
							let res1 = JSON.parse(window.atob(res.data))
							this.historyList = res1
						}
					} else {
						this.$Toast(res.msg, 'error');
					}
				})
			},
			handleInput(e) {
				
			},
			handleEnter(event) {
				event.preventDefault()
			},
			handleHistory(item) {
				let list = this.list
				list.push({
					type: 'user',
					result: item.ask
				})
				list.push({
					result: item.answer
				})
				this.list= list
				this.handleScrollBottom();
			},
			handleSub() {
				if(this.gptVal.trim() == '') {
					this.gptVal = ''
					this.$Toast('不能发送空白消息', 'error');
					return
				}
				if(this.gptVal.trim() != '') {
					let iconRule = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
					 if (iconRule.test(this.gptVal)) {
						 this.gptVal = ''
						 this.$Toast('不支持发送表情', 'error');
						 return
					 }
				}
				let list = this.list;
				this.qVal = this.gptVal
				this.gptVal = ''
				
				list.push({
					type: 'user',
					result: this.qVal
				})
				this.list = list
				this.isLoading = true
				this.handleScrollBottom();
				let data = {
					content: this.qVal,
				}
				getGpt(data).then((res) => {
					if(res.code == 200) {
						let res1 = JSON.parse(window.atob(res.data))
						list.push({
							created_at: res1.created_at,
							result: res1.result.replaceAll('\n', '<br>')
						})
						this.isLoading = false
						this.handleScrollBottom();
						
						this.list = list
					} else if(res.code == 201) {
				        list[list.length - 1].fail = 'fail'
						this.isLoading = false
				        this.list = list
						this.handleScrollBottom();
				        
				    } else if(res.code == 0) {
				        list[list.length - 1].fail = 'fail'
						this.isLoading = false
				        this.list = list
						this.handleScrollBottom();
				    } else {
						this.$Toast(res.msg, 'error');
						this.isLoading = false
					}
				})
				
			},
			handleScrollBottom() {
			  this.$nextTick(() => {
				let scrollElem = this.$refs.scrollDiv;
				scrollElem.scrollTop = scrollElem.scrollHeight;
			  });
			}
			
		}
	}
</script>

<style scoped>
	.gpt_foot >>> .el-textarea__inner {
		min-height: 150px !important;
		padding-top: 10px;
		padding-bottom: 10px;
		padding-right: 80px;
	}
	.content_wrap::-webkit-scrollbar {
		width: 0;
		height: 0;
		background-color: transparent;
	}
</style>
<style lang="scss" scoped>
	.role{
		// padding: 24px;
		width: 100%;
		height: 100%;
		overflow-y: auto;
		// border: 12px solid #F2F4FA;
		background-color: #F2F4FA;
		.pages_wrap {
			display: flex;
			width: 100%;
			position: relative;
		}
		.gpt_wrap {
			flex: 1;
			padding: 30px 10% 30px;
		}
		.gpt_header {
			width: 100%;
			text-align: center;
			
			.gpt_header_title {
				display: inline-block;
				padding: 4px 18px;
				color: #333;
				font-style: italic;
				font-size: 14px;
				background: linear-gradient(rgba(238, 233, 246), rgba(227, 229, 246)); 
				border-radius: 4px;
			}
		}
		.content_wrap {
			padding: 30px 0 0;
			overflow: auto;
		}
		.gpt_foot {
			position: relative;
			width: 100%;
			margin-top: 20px;
			
			.input_box {
				width: 100%;
			}
			.sub_btn {
				position: absolute;
				bottom: 10px;
				right: 20px;
				width: 50px;
				height: 50px;
				cursor: pointer;
			}
		}
		
		.user_avatar {
			width: 30px;
			height: 30px;
			margin-left: 5px
		}
		.medin_avatar {
			width: 40px;
			height: 40px;
		}
		
		.user_box {
			display: flex;
			align-items: flex-start;
			margin-bottom: 20px;
			
			
			.user_question {
				flex: 1;
				font-size: 15px;
				color: #000;
				margin-left: 20px;
				font-weight: bold;
				padding: 6px 0 0;
			}
		}
		.medin_box{
			position: relative;
			display: flex;
			align-items: flex-start;
			margin-bottom: 20px;
			
			.medin_answer {
				position: relative;
				flex: 1;
				font-size: 15px;
				color: #000;
				margin-left: 15px;
				background-color: #fff;
				border-radius: 10px;
				padding: 20px;
			}
			
			.medin_tip {
				position: absolute;
				bottom: 0;
				right: 0;
				padding: 4px 8px;
				font-size: 10px;
				border-radius: 10px;
				color: rgba(221,210,200);
				background-color: rgba(253,252,249);
			}
		}
		.chat_box {
			display: flex;
			align-items: flex-start;
			margin-bottom: 30px;
			
			.chat_content {
				flex: 1;
				margin-left: 15px;
				text-align: left;
				display: flex;
			}
			.chat_text {
				padding: 20px;
				word-break: break-all;
				word-wrap: break-word;
				white-space: pre-wrap;
				background-color: #fff;
				border-radius: 10px;
			}
			
			.tips1 {
				position: relative;
				display: inline-block;
				width: 16px;
				height: 16px;
				background-image: linear-gradient(90deg, #90EE90,#00FF00);
				border-radius: 6px;
				animation: fly 1.5s linear infinite;
			}
			@keyframes fly {
			  0% {
				top: 0
			  }
			  33% {
			    top: 5px
			  }
			  66% {
			    top: -5px
			  }
			  100% {
				top: 0
			  }
			}
			.tips2 {
				position: relative;
				display: inline-block;
				width: 16px;
				height: 16px;
				background-image: linear-gradient(90deg, #FFD700,#FFA500);
				border-radius: 6px;
				margin-left: 10px;
				animation: fly2 1.5s linear infinite;
			}
			@keyframes fly2 {
			  0% {
				top: 0
			  }
			  34% {
			    top: 5px
			  }
			  66% {
			    top: -5px
			  }
			  100% {
				top: 0
			  }
			}
			.tips3 {
				position: relative;
				display: inline-block;
				width: 16px;
				height: 16px;
				background-image: linear-gradient(90deg, #FF6347,#FF0000);
				border-radius: 6px;
				margin-left: 10px;
				animation: fly3 1.5s linear infinite;
			}
			@keyframes fly3 {
			  0% {
				top: 0
			  }
			  34% {
			    top: 5px
			  }
			  66% {
			    top: -5px
			  }
			  100% {
				top: 0
			  }
			}
		}
		.to_tips {
			font-size: 12px;
			color: #999;
			margin-bottom: 10px;
			text-align: center;
		}
		
		.history_list {
			width: 300px;
			background-color: #fff;
			padding: 30px 0 0;
			.history_title {
				font-size: 18px;
				color: #666;
				font-weight: 500;
				margin-bottom: 20px;
				padding: 0 20px;
			}
			.history_item_wrap {
				width: 100%;
				overflow: auto;
			}
			.history_item {
				width: 100%;
				font-size: 14px;
				color: #84868c;
				font-weight: 500;
				line-height: 30px;
				padding: 0 20px;
				cursor: pointer;
				white-space: nowrap; /* 防止文字换行 */  
				overflow: hidden;    /* 隐藏超出容器的内容 */  
				text-overflow: ellipsis; /* 用省略号表示被隐藏的文本 */ 
				
				&:hover {
					background-color: rgba(0, 0, 0, 0.1);
				}
			}
		}
		.history_menu {
			position: absolute;
			top: 8px;
			font-size: 14px;
			color: #6681fa;
			cursor: pointer;
			z-index: 99;
		}
		.aside_img {
			position: absolute;
			top: 20px;
			// right: 0;
			width: 46px;
			height: 46px;
			cursor: pointer;
			z-index: 99;
		}
		.no_history {
			width: 100%;
			margin-top: 300px;
			text-align: center;
			
			.no_data_img {
				width: 80px;
				height: 80px;
				text-align: center;
			}
			.no_data_text {
				margin-top: 10px;
			}
		}
		
	}
	.medin_desc {
		position: relative;
		flex: 1;
		font-size: 18px;
		color: #000;
		margin-left: 15px;
		background-color: #fff;
		border-radius: 10px;
		padding: 20px;
	}
	
	.medin_desc_t {
		font-size: 15px;
		color: #84868c;
		margin-top: 10px;
	}
	
</style>
